import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

export default {
  iniciarSessao: token => {
    return Vue.http.post('/api/acessoAssinatura/Sessao', { token })
      .then(resposta => resposta.data);
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/assinatura-embed/servico.js